@for (extension of headerLoginEnabledExtensions; track extension) {
    <div class="gp-pagewidth gp-pagewidth-login-form">
        <extension-loader [extension]="extension" />
    </div>
}

@for (extension of homeContentEnabledExtensions; track extension) {
    <div>
        <extension-loader [extension]="extension" />
    </div>
}
